import React from "react";
import { useBnbSelector } from "../../../redux/store";
import EmissionLabel from "../../../../../../common-deprecated/components/eco-labels/EmissionLabel";
import type { GroupedSpecType } from "../../../utils/pdfUtils";
import { getEmissionLabel } from "../../../utils/typedUtils";

type PropsType = {
    currentSpec: GroupedSpecType;
    allSpecs: GroupedSpecType[];
};

const SpecificationValue = (props: PropsType): JSX.Element => {
    const { currentSpec, allSpecs } = props;
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    // Render EmissionLabel instead when the current spec is an energy efficiency class, the ecoLabelpopup is available in the settings and the CO2 Combined WLTP value is available in the specs
    const emissionLabel = getEmissionLabel(currentSpec, allSpecs, commonSettings);
    if (emissionLabel) return <EmissionLabel label={emissionLabel} />;

    return <>{`${currentSpec.value} ${currentSpec.unit}`.trim()}</>;
};

export default SpecificationValue;
